import React from 'react';
import RegisterBNP from '../RegisterUBNP';

export default function RegisterSMEBNP() {
  return <RegisterBNP type="sme_bnp" />;
} 